import React from "react";
import PropTypes from "prop-types";

import BluGraphContainer from "./common/BluGraphContainer";

import IntrudersGraph from "./IntrudersGraph";

import "./common/BluGraphContainer.scss";

/*
Constants
*/

const REDUX_NAME = "intruders";
export const GRAPH_TITLE = "Top 10 Attackers";

/*
Main component
*/

const Intruders = ({ showTitle = false, showSubtitle = true }) => (
  <BluGraphContainer
    defaultTitle={GRAPH_TITLE}
    Graph={IntrudersGraph}
    labelField="srcIp"
    reduxName={REDUX_NAME}
    showSubtitle={showSubtitle}
    showTitle={showTitle}
  />
);

Intruders.propTypes = {
  showSubtitle: PropTypes.bool,
  showTitle: PropTypes.bool,
};

Intruders.defaultProps = {
  showSubtitle: true,
  showTitle: false,
};

export default Intruders;
